import { RVSideNavLayout, type PageSubNavItem } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { AppPagePaths } from "App/routes/paths";
import { AgentDesktopPaths } from "Pages/agentDesktop/paths";
import { SettingsPaths } from "Pages/settings/paths";
import { SETTINGS_NAV_TITLES } from "Pages/settings/settingsMetadata";
import { CollapsiblePanel } from "Utils/CollapsiblePanels";
import { useKnownPanels } from "Utils/CollapsiblePanels/knownPanels";

import { AgentSettingsPaths } from "../../Pages/paths";

export function AgentSettingsSubnav(): JSX.Element {
    const { agentSettingsPages } = usePageAvailability();
    const { mySettings } = useKnownPanels();

    const settings: Array<PageSubNavItem> = [
        {
            key: AgentSettingsPaths.integrations,
            title: SETTINGS_NAV_TITLES[AgentSettingsPaths.integrations],
            href: `/${AgentSettingsPaths.integrations}`,
            isVisible: agentSettingsPages.showEmail,
        },
        {
            key: AgentSettingsPaths.recordings,
            title: SETTINGS_NAV_TITLES[AgentSettingsPaths.recordings],
            href: `/${AgentSettingsPaths.recordings}`,
            isVisible: agentSettingsPages.showPreRecordedVmDrops,
        },
    ];

    return (
        <CollapsiblePanel panelName={mySettings.name} expandedWidth={mySettings.width}>
            <RVSideNavLayout
                sidenavTitle={SETTINGS_NAV_TITLES[SettingsPaths.mySettings]}
                items={settings}
                basePath={`${AppPagePaths.agentDesktop}/${AgentDesktopPaths.mySettings}`}
            />
        </CollapsiblePanel>
    );
}
